import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {
    jamalFull: {
        type: 'movieclip',
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: `sprite:/img/partials/intro-characters/jamal-${prefix}.json,jamal`,
        particles: [
            {
                x: '94%',
                y: '11.8%',
                angle: 310,
                emit: true,
            },
            {
                x: '94%',
                y: '12%',
                angle: 310,
                emit: true,
            },
        ],
    },

    daveFull: {
        type: 'movieclip',
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: `sprite:/img/partials/intro-characters/dave-${prefix}.json,dave`,
        particles: [
            {
                x: '86.6%',
                y: '11.8%',
                angle: 310,
                emit: true,
            },
            {
                x: '86.6%',
                y: '12%',
                angle: 310,
                emit: true,
            },
        ],
    },

    brettFull: {
        type: 'movieclip',
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: `sprite:/img/partials/intro-characters/brett-${prefix}.json,brett`,
    },

    girlFull: {
        type: 'movieclip',
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: `sprite:/img/partials/intro-characters/girl-${prefix}.json,girl`,
    },

    puppetMasterFull: {
        type: 'movieclip',
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: `sprite:/img/partials/intro-characters/puppetmaster-${prefix}.json,puppetmaster`,
    },

    jamalBackground: {
        scale: {
            // x: '100%',
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: 'sprite:/img/partials/intro-characters/backgrounds.json,background-jamal.png',
    },

    daveBackground: {
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: 'sprite:/img/partials/intro-characters/backgrounds.json,background-dave.png',
    },

    lightLinesBackground: {
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: 'sprite:/img/partials/intro-characters/backgrounds.json,background-3.png',
    },

    darkLinesBackground: {
        scale: {
            y: '100%',
        },
        position: {
            x: '0%',
            y: '0%',
        },
        texture: 'sprite:/img/partials/intro-characters/backgrounds.json,background-3.png',
    },

    backgroundStripe: {
        scale: {
            x: '100%',
            // y: '100%',
        },
        position: {
            x: '0%',
            y: '80%',
        },
        texture: 'sprite:/img/partials/intro-characters/backgrounds.json,background-stripe.png',
    },
};



// WEBPACK FOOTER //
// ./js/objects/partials/introCharacters.js